<template>
  <div>
    <b-card id="page-payment" no-body class="order-payment-card">
      <b-card-header class="payment-card-header">
        <div class="payment-heading">
          <div class="payment-heading-icon">
            <feather-icon icon="CreditCardIcon" size="19" />
          </div>
          <div>
            <h4 class="mb-25">{{ $t(label("resume")) }}</h4>
            <small class="text-muted">{{
              $t(label("paymentSummaryHelp"))
            }}</small>
          </div>
        </div>
      </b-card-header>

      <b-card-body class="payment-card-body">
        <b-row class="gx-5 justify-content-between">
          <b-col v-if="hasTransactionDetails" cols="12" lg="7">
            <div class="gx-5 d-flex justify-content-between mb-2">
              <b-card-sub-title class="pt-1">
                <strong class="text-dark">
                  {{ $t(label("transaction_detail")) }}
                </strong>
              </b-card-sub-title>
            </div>

            <div
              v-if="option !== 2 && !blockStatus"
              ref="form"
              class="repeater-form"
              :style="{ height: trHeight }"
            >
              <b-row ref="row" class="pb-2">
                <b-col cols="12" lg="6">
                  <label class="d-inline d-lg-none">{{
                    $t(label("type_payment"))
                  }}</label>
                  <v-select
                    input-id="payType"
                    v-model="paymentMethodSelected"
                    :options="allPaymentMethods"
                    :placeholder="$t(label('type_payment'))"
                    :clearable="false"
                    label="nameType"
                    class="mb-2"
                    :reduce="(option) => option.idCompanyPaymentMethods"
                  >
                    <span slot="no-options" click="$refs.payType.open = false"
                      >{{ $t("sorryOption") }}
                    </span>
                  </v-select>
                </b-col>
                <b-col cols="12" lg="6">
                  <label class="d-inline d-lg-none">{{
                    $t(label("reference"))
                  }}</label>
                  <b-form-input
                    id="referenceMethodSelected"
                    v-model="referenceMethodSelected"
                    type="text"
                    :placeholder="$t(label('reference'))"
                    class="mb-2"
                  />
                </b-col>
                <b-col cols="12" lg="6">
                  <label class="d-inline d-lg-none">{{
                    $t(label("amount"))
                  }}</label>
                  <b-form-input
                    id="amountMethodSelected"
                    v-model="amountMethodSelected"
                    type="text"
                    :placeholder="$t(label('amount'))"
                    class="mb-3"
                  />
                </b-col>
                <b-col cols="12">
                  <div class="d-flex justify-content-center">
                    <b-media class="body-style">
                      <div v-if="!urlReferenceMethodSelected && option != 2">
                        <input
                          id="inputFileReference"
                          ref="fileInputReference"
                          name="inputFileReference"
                          type="file"
                          class="hidden"
                          accept=".png,.peg,.jpg,.jpeg"
                          @change="onFileChange($event, 'photo')"
                        />
                        <div
                          class="cursor-pointer m-auto cuve text-center border-2 d-flex flex-column align-items-center justify-content-center"
                          accept=".png,.peg,.jpg,.jpeg"
                          @drop="handleDrop($event, 'photo')"
                          @dragover="handleDragover"
                          @dragenter="handleDragover"
                          @click="$refs.fileInputReference.click()"
                        >
                          <feather-icon
                            icon="UploadCloudIcon"
                            size="20"
                            svg-classes="h-16 w-16 stroke-current text-grey"
                          />
                          <span
                            style="margin-left: 5px"
                            @click.stop="$refs.fileInputReference.click()"
                          >
                            Subir imagen
                          </span>
                        </div>
                      </div>

                      <template v-if="urlReferenceMethodSelected" #aside>
                        <div class="container-image">
                          <img
                            id="image"
                            ref="image"
                            :src="urlReferenceMethodSelected"
                            class="img-pay"
                          />
                        </div>
                        <div
                          v-if="urlReferenceMethodSelected && option != 2"
                          class="d-flex flex-wrap"
                          style="width: 10px"
                        >
                          <b-button
                            variant="primary"
                            style="height: 30px; width: 30px; padding: 4px"
                            @click="deleteFile('photo')"
                          >
                            <feather-icon icon="XIcon" size="21" />
                          </b-button>
                        </div>
                      </template>
                    </b-media>
                  </div>
                </b-col>
              </b-row>
            </div>

            <div
              v-if="option !== 2 && !blockStatus"
              class="gx-5 d-flex justify-content-end mb-2"
            >
              <b-button
                :disabled="!isFormValid"
                variant="outline-success"
                class="mr-1 rounded-pill cursor-pointer"
                size="sm"
                @click="addImput"
              >
                <feather-icon icon="ShoppingCartIcon" size="18" />
              </b-button>

              <b-button
                :disabled="!isFormValid"
                variant="outline-danger"
                class="rounded-pill cursor-pointer"
                size="sm"
                @click="clearImput"
              >
                <feather-icon icon="Trash2Icon" size="18" />
              </b-button>
            </div>
            <!-- <div class="d-flex justify-content-between py-1">
                            <strong>Informacion:</strong>
                            <div style="white-space: pre-line;"> {{ referenceInformation(list.informationPayment) }} </div>
                        </div> -->

            <ul
              v-for="(list, index) in payments"
              :key="index"
              class="list-unstyled"
            >
              <hr class="invoice-spacing" />
              <div>
                <b-card-sub-title class="py-1">
                  {{ $t(label("payment_register")) }}:
                  <strong class="text-success">
                    {{ list.reference || $t(label("noReference")) }}
                  </strong>
                </b-card-sub-title>
              </div>
              <li
                class="d-flex flex-column flex-md-row justify-content-between"
              >
                <div class="flex-grow-1">
                  <div class="py-1">
                    <strong>{{ $t(label("type_payment")) }}</strong>
                    <div>
                      {{ isPaymentMethod(list.idCompanyPaymentMethods) }}
                    </div>
                  </div>

                  <div class="py-1">
                    <strong>{{ $t(label("reference")) }}</strong>
                    <div>{{ list.reference || $t(label("noReference")) }}</div>
                  </div>

                  <div class="py-1">
                    <strong
                      >{{
                        $t(label("amountInCurrency"), { currency: divisa })
                      }}:</strong
                    >
                    <div>{{ formatAmount(list.amount) }} {{ divisa }}</div>
                  </div>
                </div>

                <div>
                  <div class="d-flex justify-content-center pb-1 pt-0">
                    <b-media class="body-style pb-0">
                      <template v-if="list.urlReference" #aside>
                        <div class="container-image-mini">
                          <img
                            id="image"
                            ref="image"
                            :src="list.urlReference"
                            class="img-pay"
                          />
                        </div>
                      </template>
                    </b-media>
                  </div>
                </div>
              </li>
            </ul>
          </b-col>

          <b-col cols="12" :lg="hasTransactionDetails ? 5 : 12">
            <b-card-sub-title class="py-1">
              <strong class="text-dark">
                {{ $t(label("order_payment")) }}
              </strong>
            </b-card-sub-title>
            <ul class="list-unstyled">
              <li>
                <div
                  class="payment-summary border rounded p-2"
                  :class="{ 'payment-summary--wide': !hasTransactionDetails }"
                >
                  <div class="payment-summary-item">
                    <strong>{{ $t(label("subtotal")) }}:</strong>
                    <div>{{ formatAmount(primarySubtotal) }} {{ divisa }}</div>
                  </div>
                  <div class="payment-summary-item">
                    <strong
                      >{{
                        $t(label("iva"), { rate: formatRate(ivaRate) })
                      }}:</strong
                    >
                    <div>{{ formatAmount(ivaAmount) }} {{ divisa }}</div>
                  </div>
                  <div class="payment-summary-item payment-summary-item--total">
                    <strong>{{ $t(label("totalWithIva")) }}:</strong>
                    <div>{{ formatAmount(totalWithIva) }} {{ divisa }}</div>
                  </div>
                  <!-- <div
                    class="payment-summary-item payment-summary-item--bolivars"
                  >
                    <strong>{{ $t(label("totalInBolivars")) }}:</strong>
                    <p class="mb-0">{{ formatAmount(totalInBolivars) }} Bs</p>
                  </div> -->
                </div>
              </li>
            </ul>
          </b-col>

          <b-col
            class="d-flex justify-content-end align-items-center"
            cols="12"
          >
            <b-button
              v-if="!blockStatus && option !== 2"
              type="submit"
              variant="primary"
              class="mr-1"
              @click="$emit('submit')"
            >
              {{ $t("save") }}
            </b-button>

            <b-button
              v-if="option !== 2"
              type="reset"
              variant="outline-secondary"
              @click="$emit('back')"
            >
              {{ option !== 2 ? $t("cancel") : $t("back") }}
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import _ from "lodash";
import vSelect from "vue-select";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BPagination,
  BFormGroup,
  BForm,
  BFormSelect,
  BFormInvalidFeedback,
  VBToggle,
  VBTooltip,
  BCardText,
  BDropdownDivider,
  BFormFile,
  BCardSubTitle,
  BInputGroup,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import router from "@/router";
import { heightTransition } from "@core/mixins/ui/transition";

import { getPaymentMethodsCompany } from "@core/api/request/company";
import { postFile } from "@core/api/request/catalogs";
import { showLoading, stopLoading, getParams } from "@core/utils/utils";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    vSelect,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BPagination,
    BFormGroup,
    BForm,
    BFormSelect,
    BFormInvalidFeedback,
    VBToggle,
    VBTooltip,
    BCardText,
    BDropdownDivider,
    BFormFile,
    BMedia,
    BFormGroup,
    BCardSubTitle,
    BInputGroup,
  },

  props: {
    option: {
      type: Number,
      default: () => 0,
    },
    blockStatus: {
      type: Boolean,
      default: () => false,
    },
    payments: {
      type: Array,
      default: () => [],
    },
    paymentMethods: {
      type: Array,
      default: () => [],
    },
    detail: {
      type: Object,
      default: () => {},
    },
    idCatStatus: {
      type: Number,
      default: () => 0,
    },
    companyGuid: {
      type: String,
      default: () => null,
    },
    productsSubtotal: {
      type: Number,
      default: 0,
    },
  },
  mixins: [heightTransition],
  data() {
    return {
      loadingPhoto: false,
      userData: {},
      // DATA FOR PAYMENT
      paymentMethodSelected: null,
      referenceMethodSelected: null,
      amountMethodSelected: null,
      urlReferenceMethodSelected: null,
      allPaymentMethods: [],
    };
  },
  computed: {
    divisa() {
      return this.$store.state.appConfig.divisa || "USD";
    },
    ivaRate() {
      const rate = Number(this.$store.state.appConfig.iva);
      return Number.isFinite(rate) && rate >= 0 && rate <= 100 ? rate : 0;
    },
    primarySubtotal() {
      return this.toValidAmount(this.productsSubtotal);
    },
    primaryTotal() {
      return this.primarySubtotal;
    },
    ivaAmount() {
      return this.primarySubtotal * (this.ivaRate / 100);
    },
    totalWithIva() {
      return this.primaryTotal + this.ivaAmount;
    },
    bolivarSubtotal() {
      const officialPrimarySubtotal = this.firstPositiveAmount([
        this.detail.amount,
        this.detail.totalToPay,
      ]);
      const officialBolivarSubtotal = this.firstPositiveAmount([
        this.detail.amountVESTasaConfigurada,
        this.detail.amountVES,
      ]);
      if (officialPrimarySubtotal > 0 && officialBolivarSubtotal > 0) {
        return (
          this.primarySubtotal *
          (officialBolivarSubtotal / officialPrimarySubtotal)
        );
      }
      return this.firstPositiveAmount([
        this.detail.amountVESTasaConfigurada,
        this.detail.amountVES,
      ]);
    },
    bolivarTotal() {
      return this.bolivarSubtotal;
    },
    totalInBolivars() {
      const ivaInBolivars = this.bolivarSubtotal * (this.ivaRate / 100);
      return this.bolivarTotal + ivaInBolivars;
    },
    hasTransactionDetails() {
      return (
        (this.option !== 2 && !this.blockStatus) || this.payments.length > 0
      );
    },
    isFormValid() {
      return (
        this.paymentMethodSelected !== null &&
        this.referenceMethodSelected !== null &&
        this.amountMethodSelected !== null &&
        this.urlReferenceMethodSelected !== null
      );
    },
  },
  watch: {
    paymentMethods: {
      handler(newValue) {
        // Reinicia el valor de paymentMethodSelected cuando cambien los métodos de pago
        this.paymentMethodSelected = null;
      },
      immediate: true, // Opcional: ejecuta el watcher al inicio
      deep: false, // No necesitas observar cambios profundos, solo la referencia
    },
  },

  created() {
    window.addEventListener("resize", this.initTrHeight);
    this.userData = this.$store.state.appConfig.user;
    this.initTrHeight();
    this.loadPaymentsByCompanie();
  },

  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },

  mounted() {},

  methods: {
    label(field) {
      return `pages.orders.form.label.${field}`;
    },

    referenceInformation(value) {
      if (!value) return "";
      return value.replace(/\\n/g, "\n");
    },

    mountFormt(value) {
      const mount = parseFloat(value);
      return Math.floor(mount * 100) / 100;
    },

    formatAmount(value) {
      const amount = Number(value);
      if (!Number.isFinite(amount)) return "-";
      return amount.toLocaleString(this.$i18n.locale || "es-VE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    formatRate(value) {
      const rate = Number(value);
      return Number.isFinite(rate) ? rate.toLocaleString(this.$i18n.locale) : 0;
    },

    toValidAmount(value) {
      const amount = Number(value);
      return Number.isFinite(amount) ? amount : 0;
    },

    firstValidAmount(values) {
      const value = values.find((item) => Number.isFinite(Number(item)));
      return this.toValidAmount(value);
    },

    firstPositiveAmount(values) {
      const value = values.find((item) => {
        const amount = Number(item);
        return Number.isFinite(amount) && amount > 0;
      });
      return this.toValidAmount(value);
    },

    isPaymentMethod(id) {
      console.log("ID", id, this.paymentMethods);
      const method = this.paymentMethods.find(
        (item) => item.idCompanyPaymentMethods === id,
      );
      return method ? method.nameType : "";
    },

    removeForm() {
      this.amountMethodSelected =
        this.referenceMethodSelected =
        this.urlReferenceMethodSelected =
        this.paymentMethodSelected =
          null;
    },

    addPay() {
      const data = {
        amount: this.amountMethodSelected,
        reference: this.referenceMethodSelected,
        urlReference: this.urlReferenceMethodSelected,
        idCompanyPaymentMethods: this.paymentMethodSelected,
        idCatStatus: null,
      };
      this.removeForm();
      this.$emit("updatePeyment", data);
    },

    async loadPaymentsByCompanie() {
      await getPaymentMethodsCompany(this.companyGuid)
        .then((resp) => {
          const data = _.get(resp, "data");
          this.allPaymentMethods = data.items;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    onFileChange(e, field) {
      // if (e?.target?.files?.length > 0) {
      //     this.onTransFile(
      //         e?.target?.files,
      //         e.target.accept,
      //         e.target.multiple,
      //         field
      //     );
      // }
      const files = e?.target?.files || e.dataTransfer?.files;
      if (files && files.length > 0) {
        const file = files[0];
        const validFormats = ["jpeg", "jpg", "png"];
        const fileType = file.type.split("/").pop();

        if (validFormats.includes(fileType)) {
          this.loadingPhoto = true;
          postFile(file)
            .then((resp) => {
              this.urlReferenceMethodSelected = resp.data;
            })
            .finally(() => {
              this.loadingPhoto = false;
            });
        } else {
          this.$toast.warning(this.$t("invalidFileType"));
        }
      }
    },

    onTransFile(files, accept, multiple, field) {
      if (multiple) return;
      this.loadingPhoto = true;
      files.forEach((file) => {
        if (!file) return;
        const type = file.type.split("/").pop();
        const isPdf = type === "pdf";
        const isImage = ["jpeg", "jpg", "png"].includes(type);
        if (!isPdf && !isImage) return;
        showLoading();
        postFile(file)
          .then((resp) => {
            this.urlReferenceMethodSelected = resp.data;
          })
          .catch(console.error)
          .finally(() => {
            this.loadingPhoto = false;
            stopLoading();
          });
      });
    },

    handleDrop(e, field) {
      e.stopPropagation();
      e.preventDefault();
      const { files } = e.dataTransfer;
      if (files.length !== 1) {
        return;
      }
      const accept =
        e.target.getAttribute("accept") ||
        e.target.parentElement.getAttribute("accept");
      const multiple =
        e.target.getAttribute("multiple") ||
        e.target.parentElement.getAttribute("multiple");
      this.onTransFile(files, accept, multiple, field);
    },

    handleDragover(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
    },

    deleteFile(field) {
      this.urlReferenceMethodSelected = null;
    },

    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {});
    },

    addImput() {
      this.$swal({
        title: this.$t("areYouSure"),
        icon: "success",
        showCancelButton: true,
        confirmButtonText: this.$t("yesAdd"),
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.addPay();
        }
      });
    },

    clearImput() {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("willNotBeAble"),
        target: "body",
        inputLabel: `Escribe ${this.userData.Name} para confirmar`,
        input: "text",
        inputPlaceholder: `${this.userData.Name}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("edit"),
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
        inputValidator: (value) =>
          new Promise((resolve) => {
            const stringValue = this.userData.Name;
            if (value === stringValue) {
              resolve();
            } else {
              resolve(`Tu necesita escribir ${this.userData.Name}`);
            }
          }),
      }).then((result) => {
        if (result.isConfirmed) {
          this.removeForm();
          this.$swal.close();
        }
      });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.body-padding {
  .card-body {
    padding: 2px 1.5rem;
  }
}

.processPayment-title {
  font-weight: 900;
  padding-top: 1.5rem;
}
</style>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "~@core/scss/base/components/variables-dark";

.form-section {
  .border {
    background-color: #000;
  }
}
.dark-layout .form-section {
  background-color: $theme-dark-card-bg;
  .border {
    background-color: $theme-dark-body-bg;
  }
}

.repeater-form {
  // overflow: hidden;
  transition: 0.35s height;
}

.order-payment-card {
  overflow: hidden;
  border: 0;
  border-radius: 0.65rem;
  box-shadow: 0 4px 18px rgba(34, 41, 47, 0.08);
}

.payment-card-header,
.payment-heading,
.payment-heading-icon {
  display: flex;
  align-items: center;
}

.payment-card-header {
  padding: 1.5rem;
}

.payment-heading {
  min-width: 0;
  gap: 0.85rem;
}

.payment-heading-icon {
  justify-content: center;
  width: 2.65rem;
  height: 2.65rem;
  flex: 0 0 2.65rem;
  color: #00cfe8;
  border-radius: 0.65rem;
  background: rgba(0, 207, 232, 0.12);
}

.payment-card-body {
  padding: 0 1.5rem 1.5rem;
}

.payment-summary {
  display: flex;
  flex-direction: column;
}

.payment-summary-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 0.9rem 0;
}

.payment-summary-item + .payment-summary-item {
  border-top: 1px solid rgba(34, 41, 47, 0.08);
}

.payment-summary-item--total,
.payment-summary-item--bolivars {
  font-weight: 600;
}

@media (min-width: 992px) {
  .payment-summary--wide {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    padding: 0 !important;
  }

  .payment-summary--wide .payment-summary-item {
    min-height: 6rem;
    padding: 1.25rem 1.5rem;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }

  .payment-summary--wide .payment-summary-item + .payment-summary-item {
    border-top: 0;
    border-left: 1px solid rgba(34, 41, 47, 0.08);
  }
}

@media (max-width: 767.98px) {
  .payment-card-body {
    padding: 0 1rem 1rem;
  }
}

.v-select {
  &.item-selector-title,
  &.payment-selector {
    background-color: #fff;

    .dark-layout & {
      background-color: unset;
    }
  }
}
</style>
